export const hasRole = (role) => {
  if (typeof role !== "string" || !role.trim() || typeof localStorage === "undefined") {
    return false;
  }

  const storedRoles = localStorage.getItem("roles");
  if (!storedRoles) {
    return false;
  }

  let roles;
  try {
    roles = JSON.parse(storedRoles);
  } catch {
    roles = storedRoles;
  }

  if (typeof roles === "string") {
    roles = roles.split(",");
  }

  if (!Array.isArray(roles)) {
    return false;
  }

  const expectedRole = role.trim();
  return roles.some(
    (storedRole) =>
      typeof storedRole === "string" && storedRole.trim() === expectedRole
  );
};
